import { Skeleton } from '../primitives/Skeleton'
import { RosterHeader } from './RosterHeader'
import { ROSTER_GRID_TEMPLATE, ROSTER_GRID_GAP, ROSTER_ROW_PAD_X } from '../../lib/roster-format'

/**
 * Loading placeholder that mirrors the real roster layout — a summary card
 * block, the column header, and a handful of grid rows shaped like RosterRow
 * (rhythm avatar + identity, next leave) — so the page reveals its structure
 * before data lands rather than flashing generic bars.
 */
export function RosterSkeleton({ rows = 6 }: { rows?: number }): JSX.Element {
  return (
    <div>
      {/* Summary note placeholder */}
      <Skeleton width="60%" height={16} radius={4} style={{ marginBottom: 20 }} />

      <RosterHeader />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            style={{
              display: 'grid',
              gridTemplateColumns: ROSTER_GRID_TEMPLATE,
              columnGap: ROSTER_GRID_GAP,
              alignItems: 'center',
              padding: `10px ${ROSTER_ROW_PAD_X}px`,
              minHeight: 56,
              border: '1px solid var(--border)',
              borderRadius: 12,
              background: 'var(--surface)',
            }}
          >
            {/* Person: avatar + name/title */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
              <Skeleton width={36} height={36} radius={18} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 1, minWidth: 0 }}>
                <Skeleton width="70%" height={12} radius={4} />
                <Skeleton width="45%" height={10} radius={4} />
              </div>
            </div>
            {/* Next leave */}
            <Skeleton width="60%" height={12} radius={4} />
          </div>
        ))}
      </div>
    </div>
  )
}
